import styled from 'styled-components';

export const CommentLabelText = styled.span`
  padding: 2px 8px;
  border-radius: 0px 0px 0px 5px;
  background-color: ${(props) => props.theme.colours.companyColour};
  color: ${(props) => props.theme.colours.readableColorOnMainColour};
  margin-left: 5px;
  float: right;
`;

export default CommentLabelText;
